"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommercialOfferTable = void 0;
const mithril_1 = __importDefault(require("mithril"));
const app_1 = require("../../../app");
const commercial_offer_1 = require("../../../model/commercial_offer");
const helpers_1 = require("../../../utils/helpers");
const table_renderers_1 = require("../../../utils/table_renderers");
const right_panel_1 = require("../../../widgets/right_panel");
const table_1 = require("../../../widgets/table");
const commercial_offer_form_1 = require("./commercial_offer_form");
exports.CommercialOfferTable = (0, table_1.createTable)({
    id: "commercialOfferTable",
    title: "Offre commerciale",
    provider: commercial_offer_1.CommercialOfferProvider,
    topMenuRight: () => {
        return [
            (0, mithril_1.default)("a", { class: "button is-success with-margin", onclick: () => { commercial_offer_form_1.CommercialOfferForm.show(); } }, (0, mithril_1.default)("span", { class: "icon is-small" }, (0, mithril_1.default)("i", { class: "fas fa-plus" })), (0, mithril_1.default)("span", "Nouvelle offre"))
        ];
    },
    filters: [],
    fields: [
        {
            name: "id",
            sortable: true,
            label: "n°"
        },
        {
            name: "name",
            sortable: true,
            label: "Nom"
        },
        {
            name: "active",
            sortable: false,
            label: "Actif",
            renderer: (x, value) => {
                return (0, mithril_1.default)("a", { onclick: () => {
                        app_1.App.get(`/commercial_offers/${x.id}/toggle_activation`).then((data) => {
                            x.active = data.active;
                        });
                    } }, table_renderers_1.TableRenderers.bool(x, value));
            }
        },
        {
            name: "total_minutes",
            sortable: true,
            label: "Temps total",
            renderer: table_renderers_1.TableRenderers.time
        },
        {
            name: "value",
            sortable: true,
            label: "Valeur (TTC)",
            renderer: (x, value) => { return table_renderers_1.TableRenderers.money(x, (0, helpers_1.withVAT)(value)); }
        },
        {
            name: "contract_count",
            sortable: false,
            label: "# Forfaits"
        },
        {
            name: "created_at",
            sortable: true,
            label: "Créé le",
            renderer: table_renderers_1.TableRenderers.date
        }
    ],
    actions: function (obj) {
        return (0, mithril_1.default)("div", { class: "" }, (0, mithril_1.default)("a", { class: "button is-primary with-margin", onclick: () => { right_panel_1.RightPanel.open("commercial_offers", obj.id, "show"); } }, "Afficher"));
    }
});
